import { useContext } from 'react';

import { getApprovalKeyword } from '@atom/components/common/requests/customTenantUtilities';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';

import ViewRequestContext from '../ViewRequestContext';

import classes from './sddotView.module.css';

const ApprovalDisplay = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const approvalKeyword = getApprovalKeyword(activeRequest.status);
  const approvalKeywordSuffix = approvalKeyword === 'Approve' ? 'd' : 'ed';

  const isApproved =
    activeRequest.status === AssetRequestStatus.FULL_APPROVAL ||
    activeRequest.status === AssetRequestStatus.PARTIAL_APPROVAL;

  const timestampText = `${approvalKeyword}${approvalKeywordSuffix} by ${
    activeRequest?.updatedBy?.firstName
  } ${activeRequest?.updatedBy?.lastName} on ${getDisplayDateTime(
    activeRequest?.updatedDate,
  )}`;

  return (
    <div className={classes.approvalForm}>
      <div
        className={classes.formTitle}
      >{`Request ${approvalKeyword}${approvalKeywordSuffix}`}</div>
      {isApproved && (
        <div className={classes.viewRow}>
          <div className={classes.rowTitle}>{`Approved Quantity (${
            activeRequest?.assetUnit || ''
          })`}</div>
          <div>{activeRequest?.quantityApproved}</div>
        </div>
      )}
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Comments</div>
        <div>{activeRequest?.comments}</div>
      </div>
      <div className={classes.createdSubtext}>{timestampText}</div>
    </div>
  );
};

export default ApprovalDisplay;
